import React from 'react';
import { Link } from 'react-router-dom';
import { COMPANY, FOOTER_SECTIONS } from '../../utils/constants';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-grid">
          {/* Company Info */}
          <div className="footer-section">
            <h3 className="footer-title">
              SEVEN<span style={{ color: 'var(--color-blue-light)' }}>HC</span>
            </h3>
            <p className="footer-description">
              Transform your business with innovative IT solutions. We deliver cutting-edge software development and enterprise solutions.
            </p>
            <div className="footer-contact">
              <p>
                <strong>Email:</strong>{' '}
                <a href={`mailto:${COMPANY.email}`}>{COMPANY.email}</a>
              </p>
              <p>
                <strong>Phone:</strong>{' '}
                <a href={`tel:${COMPANY.phone}`}>{COMPANY.phone}</a>
              </p>
            </div>
          </div>

          {/* Footer Sections */}
          {FOOTER_SECTIONS.map((section) => (
            <div key={section.title} className="footer-section">
              <h4 className="footer-subtitle">{section.title}</h4>
              <ul className="footer-links">
                {section.links.map((link) => (
                  <li key={link.path}>
                    <Link to={link.path}>{link.name}</Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="footer-bottom">
          <p>&copy; {currentYear} SEVENHC. All rights reserved.</p>
          <div className="footer-legal">
            <Link to="/privacy">Privacy</Link>
            <span>•</span>
            <Link to="/terms">Terms</Link>
            <span>•</span>
            <Link to="/cookie-policy">Cookie Policy</Link>
            <span>•</span>
            <button 
              onClick={() => window.dispatchEvent(new Event('openCookiePreferences'))}
              style={{
                background: 'none',
                border: 'none',
                color: 'inherit',
                cursor: 'pointer',
                padding: 0,
                font: 'inherit',
                textDecoration: 'underline'
              }}
            >
              Cookie Settings
            </button>
          </div>
          <div className="footer-social">
            <a href="https://linkedin.com/company/sevenhc" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn">
              <svg
                width="20"
                height="20"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
              >
                <path d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6z"></path>
                <rect x="2" y="9" width="4" height="12"></rect>
                <circle cx="4" cy="4" r="2"></circle>
              </svg>
            </a>
            <a href="https://twitter.com/sevenhc" target="_blank" rel="noopener noreferrer" aria-label="Twitter">
              <svg
                width="20"
                height="20"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
              >
                <path d="M23 3a10.9 10.9 0 0 1-3.14 1.53 4.48 4.48 0 0 0-7.86 3v1A10.66 10.66 0 0 1 3 4s-4 9 5 13a11.64 11.64 0 0 1-7 2c9 5 20 0 20-11.5a4.5 4.5 0 0 0-.08-.83A7.72 7.72 0 0 0 23 3z"></path>
              </svg>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
